import { c as _c } from "react/compiler-runtime";
// import { useState } from "react"
import { NavigationMenuContent, NavigationMenuItem, NavigationMenuLink, NavigationMenuTrigger } from "@/components/business/header/navigation-menu";
import { getCurrentLanguageInClient } from "@/lib/utils.client";
import { useTracking } from "@/track";
import { CMSLink, CMSText } from "../../cms/components/cms-items";
import type { CmsContentHeader, HeaderConfigType, ImageTextItem, TextItem } from "../../cms/schema";
import type { CMSLinkData } from "../../cms/types";
import { getLinkUrl, getTranslatedText } from "../../cms/utils.server";
import { HoverUnderline } from "./hover-underline";
import { ImageTextItemRenderer } from "./image-text-item-renderer";
export const NavItemRenderer = t0 => {
  const $ = _c(103);
  const {
    item,
    hoveredItem,
    prevHoveredItem,
    hoverKey,
    onItemHover
  } = t0;
  const {
    track,
    TrackingEventType
  } = useTracking();
  const itemTitle = item.title_trans;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getCurrentLanguageInClient();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const lang = t1;
  let t2;
  if ($[1] !== TrackingEventType.CLICK || $[2] !== itemTitle || $[3] !== track) {
    t2 = (navigationType, url, secondNavName) => {
      track("PopMartGlobalWebNavigationClick", {
        navigation_name: navigationType === "second_navigation" ? getTranslatedText(lang, secondNavName) : getTranslatedText(lang, itemTitle),
        navigation_type: navigationType,
        main_navigation_name: getTranslatedText(lang, itemTitle),
        second_navigation_name: navigationType === "second_navigation" ? getTranslatedText(lang, secondNavName) : "",
        third_navigation_name: navigationType === "third_navigation" ? getTranslatedText(lang, itemTitle) : "",
        jump_url: url
      }, TrackingEventType.CLICK);
    };
    $[1] = TrackingEventType.CLICK;
    $[2] = itemTitle;
    $[3] = track;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleNavigationClick = t2;
  if (item.type === "link") {
    const linkData = item.data as {
      link: CMSLinkData;
    };
    let t3;
    if ($[5] !== linkData.link) {
      t3 = getLinkUrl(linkData.link) || "#";
      $[5] = linkData.link;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    const url_0 = t3;
    const linkId = `nav-link-${item.id}`;
    let t4;
    if ($[7] !== handleNavigationClick || $[8] !== url_0) {
      t4 = () => handleNavigationClick("main_navigation", url_0);
      $[7] = handleNavigationClick;
      $[8] = url_0;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] !== linkId || $[11] !== onItemHover) {
      t5 = () => {
        onItemHover(linkId);
      };
      $[10] = linkId;
      $[11] = onItemHover;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    let t6;
    if ($[13] !== onItemHover) {
      t6 = () => {
        onItemHover(null);
      };
      $[13] = onItemHover;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    let t7;
    if ($[15] !== itemTitle) {
      t7 = <CMSText text={itemTitle} />;
      $[15] = itemTitle;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    const t8 = hoveredItem === linkId;
    const t9 = prevHoveredItem === linkId && hoveredItem !== linkId;
    const t10 = `highlight-${linkId}-${hoverKey}`;
    let t11;
    if ($[17] !== t10 || $[18] !== t8 || $[19] !== t9) {
      t11 = <HoverUnderline isActive={t8} isExiting={t9} uniqueKey={t10} />;
      $[17] = t10;
      $[18] = t8;
      $[19] = t9;
      $[20] = t11;
    } else {
      t11 = $[20];
    }
    let t12;
    if ($[21] !== t11 || $[22] !== t4 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7) {
      t12 = <button type="button" className="font-normal  inline-block h-8 py-2 bg-transparent px-4 rounded-md text-xs whitespace-nowrap transition-all duration-200 hover:cursor-pointer relative" onClick={t4} onMouseEnter={t5} onMouseLeave={t6}>{t7}{t11}</button>;
      $[21] = t11;
      $[22] = t4;
      $[23] = t5;
      $[24] = t6;
      $[25] = t7;
      $[26] = t12;
    } else {
      t12 = $[26];
    }
    let t13;
    if ($[27] !== linkData.link || $[28] !== t12) {
      t13 = <CMSLink link={linkData.link}>{t12}</CMSLink>;
      $[27] = linkData.link;
      $[28] = t12;
      $[29] = t13;
    } else {
      t13 = $[29];
    }
    let t14;
    if ($[30] !== item.id || $[31] !== t13) {
      t14 = <NavigationMenuItem key={item.id}>{t13}</NavigationMenuItem>;
      $[30] = item.id;
      $[31] = t13;
      $[32] = t14;
    } else {
      t14 = $[32];
    }
    return t14;
  }
  if (item.type === "textOnly") {
    const textData = item.data as {
      textItems: TextItem[];
    };
    if (!textData.textItems || textData.textItems.length === 0) {
      return null;
    }
    const textOnlyId = `nav-textonly-${item.id}`;
    const t3 = item.id;
    let t4;
    if ($[33] !== handleNavigationClick) {
      t4 = () => handleNavigationClick("main_navigation", "#");
      $[33] = handleNavigationClick;
      $[34] = t4;
    } else {
      t4 = $[34];
    }
    let t5;
    if ($[35] !== onItemHover || $[36] !== textOnlyId) {
      t5 = () => {
        onItemHover(textOnlyId);
      };
      $[35] = onItemHover;
      $[36] = textOnlyId;
      $[37] = t5;
    } else {
      t5 = $[37];
    }
    let t6;
    if ($[38] !== onItemHover) {
      t6 = () => {
        onItemHover(null);
      };
      $[38] = onItemHover;
      $[39] = t6;
    } else {
      t6 = $[39];
    }
    let t7;
    if ($[40] !== itemTitle) {
      t7 = <CMSText text={itemTitle} />;
      $[40] = itemTitle;
      $[41] = t7;
    } else {
      t7 = $[41];
    }
    const t8 = hoveredItem === textOnlyId;
    const t9 = prevHoveredItem === textOnlyId && hoveredItem !== textOnlyId;
    const t10 = `highlight-${textOnlyId}-${hoverKey}`;
    let t11;
    if ($[42] !== t10 || $[43] !== t8 || $[44] !== t9) {
      t11 = <HoverUnderline isActive={t8} isExiting={t9} uniqueKey={t10} />;
      $[42] = t10;
      $[43] = t8;
      $[44] = t9;
      $[45] = t11;
    } else {
      t11 = $[45];
    }
    let t12;
    if ($[46] !== t11 || $[47] !== t4 || $[48] !== t5 || $[49] !== t6 || $[50] !== t7) {
      t12 = <NavigationMenuTrigger className="text-xs py-2 bg-transparent whitespace-nowrap hover:cursor-pointer transition-all duration-200 relative" onClick={t4} onMouseEnter={t5} onMouseLeave={t6}>{t7}{t11}</NavigationMenuTrigger>;
      $[46] = t11;
      $[47] = t4;
      $[48] = t5;
      $[49] = t6;
      $[50] = t7;
      $[51] = t12;
    } else {
      t12 = $[51];
    }
    let t13;
    if ($[52] !== handleNavigationClick || $[53] !== item.id || $[54] !== textData.textItems) {
      let t14;
      if ($[56] !== handleNavigationClick || $[57] !== item.id) {
        t14 = (textItem, index) => <li key={`textItem-${item.id}-${index}-${textItem.text ? String(textItem.text).substring(0, 10) : index}`}><NavigationMenuLink href={getLinkUrl(textItem.link) || "#"} className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-[#d2001e] focus:bg-accent focus:text-accent-foreground hover:cursor-pointer" onClick={() => handleNavigationClick("second_navigation", textItem.link?.externalUrl || textItem.link?.internalUrl || "#", textItem.text)}><CMSText text={textItem.text} /></NavigationMenuLink></li>;
        $[56] = handleNavigationClick;
        $[57] = item.id;
        $[58] = t14;
      } else {
        t14 = $[58];
      }
      t13 = textData.textItems.map(t14);
      $[52] = handleNavigationClick;
      $[53] = item.id;
      $[54] = textData.textItems;
      $[55] = t13;
    } else {
      t13 = $[55];
    }
    let t14;
    if ($[59] !== t13) {
      t14 = <NavigationMenuContent><div className="flex justify-center w-full"><div className="inline-block w-auto p-6 max-w-[1200px]"><ul className="list-none p-0 m-0 flex flex-col gap-2">{t13}</ul></div></div></NavigationMenuContent>;
      $[59] = t13;
      $[60] = t14;
    } else {
      t14 = $[60];
    }
    let t15;
    if ($[61] !== item.id || $[62] !== t12 || $[63] !== t14) {
      t15 = <NavigationMenuItem key={t3}>{t12}{t14}</NavigationMenuItem>;
      $[61] = item.id;
      $[62] = t12;
      $[63] = t14;
      $[64] = t15;
    } else {
      t15 = $[64];
    }
    return t15;
  }
  const imageTextLayoutTypes = ["largeImageTopBottom", "mediumImageTopBottom", "smallImageLeftRight"];
  if (imageTextLayoutTypes.includes(item.type as HeaderConfigType)) {
    const imageTextData = item.data as {
      imageTextItems: ImageTextItem[];
    };
    if (!imageTextData.imageTextItems || imageTextData.imageTextItems.length === 0) {
      return null;
    }
    if (item.type === "largeImageTopBottom") {} else {
      if (item.type === "mediumImageTopBottom") {} else {
        if (item.type === "smallImageLeftRight") {}
      }
    }
    const imageTextTriggerId = `nav-imagetext-${item.id}`;
    const t3 = item.id;
    let t4;
    if ($[65] !== handleNavigationClick) {
      t4 = () => handleNavigationClick("main_navigation", "#");
      $[65] = handleNavigationClick;
      $[66] = t4;
    } else {
      t4 = $[66];
    }
    let t5;
    if ($[67] !== imageTextTriggerId || $[68] !== onItemHover) {
      t5 = () => {
        onItemHover(imageTextTriggerId);
      };
      $[67] = imageTextTriggerId;
      $[68] = onItemHover;
      $[69] = t5;
    } else {
      t5 = $[69];
    }
    let t6;
    if ($[70] !== onItemHover) {
      t6 = () => {
        onItemHover(null);
      };
      $[70] = onItemHover;
      $[71] = t6;
    } else {
      t6 = $[71];
    }
    let t7;
    if ($[72] !== itemTitle) {
      t7 = <CMSText text={itemTitle} />;
      $[72] = itemTitle;
      $[73] = t7;
    } else {
      t7 = $[73];
    }
    const t8 = hoveredItem === imageTextTriggerId;
    const t9 = prevHoveredItem === imageTextTriggerId && hoveredItem !== imageTextTriggerId;
    const t10 = `highlight-${imageTextTriggerId}-${hoverKey}`;
    let t11;
    if ($[74] !== t10 || $[75] !== t8 || $[76] !== t9) {
      t11 = <HoverUnderline isActive={t8} isExiting={t9} uniqueKey={t10} />;
      $[74] = t10;
      $[75] = t8;
      $[76] = t9;
      $[77] = t11;
    } else {
      t11 = $[77];
    }
    let t12;
    if ($[78] !== t11 || $[79] !== t4 || $[80] !== t5 || $[81] !== t6 || $[82] !== t7) {
      t12 = <NavigationMenuTrigger className="text-xs py-2 bg-transparent whitespace-nowrap hover:cursor-pointer transition-all duration-200 relative" onClick={t4} onMouseEnter={t5} onMouseLeave={t6}>{t7}{t11}</NavigationMenuTrigger>;
      $[78] = t11;
      $[79] = t4;
      $[80] = t5;
      $[81] = t6;
      $[82] = t7;
      $[83] = t12;
    } else {
      t12 = $[83];
    }
    const t13 = `${item.type === "largeImageTopBottom" ? "max-w-[1112px] grid grid-gap-4 grid-auto-flow-row justify-center" : item.type === "mediumImageTopBottom" ? "max-w-[800px] mx-auto grid" : "max-w-[1200px]"}`;
    let t14;
    if ($[84] !== item.type) {
      t14 = item.type === "largeImageTopBottom" ? {
        display: "grid",
        gridGap: "16px",
        gridTemplateColumns: "repeat(auto-fit, minmax(300px, 360px))"
      } : item.type === "mediumImageTopBottom" ? {
        display: "grid",
        gridGap: "16px",
        gridTemplateColumns: "repeat(auto-fit, minmax(100px, 120px))",
        gridAutoFlow: "row",
        justifyContent: "center"
      } : {
        display: "grid",
        gridGap: "16px",
        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 240px))",
        gridAutoFlow: "row",
        justifyContent: "center"
      };
      $[84] = item.type;
      $[85] = t14;
    } else {
      t14 = $[85];
    }
    let t15;
    if ($[86] !== handleNavigationClick || $[87] !== imageTextData.imageTextItems || $[88] !== item.id || $[89] !== item.type) {
      let t16;
      if ($[91] !== handleNavigationClick || $[92] !== item.id || $[93] !== item.type) {
        t16 = (imageTextItem, index_0) => {
          const url_1 = getLinkUrl(imageTextItem.link) || "#";
          return <ImageTextItemRenderer key={`imageTextItem-${item.id}-${index_0}-${imageTextItem.text ? String(imageTextItem.text).substring(0, 10) : index_0}`} item={imageTextItem} layoutType={item.type as HeaderConfigType} onClick={() => handleNavigationClick("second_navigation", url_1, imageTextItem.text)} />;
        };
        $[91] = handleNavigationClick;
        $[92] = item.id;
        $[93] = item.type;
        $[94] = t16;
      } else {
        t16 = $[94];
      }
      t15 = imageTextData.imageTextItems.map(t16);
      $[86] = handleNavigationClick;
      $[87] = imageTextData.imageTextItems;
      $[88] = item.id;
      $[89] = item.type;
      $[90] = t15;
    } else {
      t15 = $[90];
    }
    let t16;
    if ($[95] !== t13 || $[96] !== t14 || $[97] !== t15) {
      t16 = <NavigationMenuContent><div className="flex justify-center w-full"><div className="inline-block w-auto p-6 max-w-[1440px]"><div className={t13} style={t14}>{t15}</div></div></div></NavigationMenuContent>;
      $[95] = t13;
      $[96] = t14;
      $[97] = t15;
      $[98] = t16;
    } else {
      t16 = $[98];
    }
    let t17;
    if ($[99] !== item.id || $[100] !== t12 || $[101] !== t16) {
      t17 = <NavigationMenuItem key={t3}>{t12}{t16}</NavigationMenuItem>;
      $[99] = item.id;
      $[100] = t12;
      $[101] = t16;
      $[102] = t17;
    } else {
      t17 = $[102];
    }
    return t17;
  }
  return null;
};